import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@glu/theming';
import styles from './checkbox.styles';
import { JSSClasses } from '../../proptypes/jss-prop-types';

export const CheckboxComponent = ({
  checked,
  className,
  classes: { container, hidden, icon, styledCheckbox },
  disabled,
  id,
  label,
  labelStyle,
  ...props
}) => (
  <div className={classnames(className, container)}>
    <input
      className={hidden}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      id={id}
      {...props}
    />
    <div className={classnames(styledCheckbox, { checked, disabled })}>
      <svg className={icon} viewBox="0 0 24 24" aria-hidden focusable="false">
        <polyline points="19 3 9 17 3 10" />
      </svg>
    </div>
    {label && (
      <label style={labelStyle} htmlFor={id}>
        {label}
      </label>
    )}
  </div>
);

CheckboxComponent.defaultProps = {
  classes: {},
  onChange() {},
  checked: false,
  disabled: false,
  className: '',
  label: '',
  id: '',
  labelStyle: {}
};

CheckboxComponent.propTypes = {
  classes: JSSClasses,
  className: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  labelStyle: PropTypes.shape({})
};

export default withStyles(styles)(CheckboxComponent);
